import { Link } from "@tanstack/react-router"
import { ArrowRight } from "lucide-react"
import { Button } from "@/components/ui/button"

const GRID_CELL_IDS = Array.from({ length: 100 }, (_, i) => `grid-cell-${i}`)

export function NotFound() {
  return (
    <div className="from-background to-secondary/10 flex min-h-screen flex-col items-center justify-center bg-gradient-to-b p-4">
      <div className="w-full max-w-3xl space-y-4 lg:space-y-8">
        <div className="bg-primary/5 border-primary/10 relative flex h-64 items-center justify-center overflow-hidden rounded-lg border sm:h-80">
          <div className="absolute inset-0 grid grid-cols-10 grid-rows-10 opacity-10">
            {GRID_CELL_IDS.map((id, i) => (
              <div
                key={id}
                className="border-primary/30 border-1"
                style={{
                  opacity: (i * 0.007 + 0.5) % 1,
                }}
              />
            ))}
          </div>

          <div className="relative z-10 text-center">
            <div className="text-primary mb-4 text-8xl font-black tracking-tighter sm:text-9xl">
              404
            </div>
            <div className="text-foreground text-xl font-medium sm:text-2xl">Page Not Found</div>
          </div>

          <div className="from-background/80 absolute right-0 bottom-0 left-0 h-1/3 bg-gradient-to-t to-transparent" />
        </div>

        <div className="flex justify-center">
          <Button asChild variant="outline" size="lg" className="group">
            <Link to="/dashboard" search={{ token: undefined }}>
              Back to Home
              <ArrowRight />
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
